class PopupNotifications extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('.close-popup');
      const issetPopup = this.getCookie("timeOpenPopupAgain");
      this.form = this.querySelector(".js-popup-form");
      if(!issetPopup){
        const popupModal = this.querySelector('#popup-subscribe');
        console.log(popupModal);
        popupModal.style.display = 'block';
      }
      button.addEventListener('click', (event) => {
        this.hidePopup(event);
      });
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    
    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    
    hidePopup(event) {
        const getDayExpCookie = 1;
        const timeOpenPopupAgain = true;
        this.setCookie("timeOpenPopupAgain", timeOpenPopupAgain, getDayExpCookie);
        const popupModal = this.querySelector('#popup-subscribe');
      
        popupModal.style.display = 'none';
    }
  }
  
  customElements.define('popup-notifications', PopupNotifications);
  
  